module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-1440w.10656876.webp";